module.exports = __webpack_public_path__ + "assets/img/2.bcf06ea7.png";